var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.name},[_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"href":_vm.IconName}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }